const moduleName = "Notificaciones";

const READ_NOTIFICATIONS = "Ver notificaciones";

export default {
  moduleName,
  READ_NOTIFICATIONS
};
